module.exports = __webpack_public_path__ + "img/somali-vowel-chart.3d1f9a9f.png";